module.exports = __webpack_public_path__ + "images/ethnography_of_daos.png?v=5fd6577530e14fbd4aeebcc9f4cb17a1";